import React from 'react';
import ProductCard from './ProductCard';
import { useLanguage } from '../../context/LanguageContext';
import './ProductCard.css';

const ProductGrid = ({ products = [], onAddToCart, onAddToWishlist }) => {
  const { t } = useLanguage();

  if (!Array.isArray(products) || products.length === 0) {
    return <p>{t('common.noProductsAvailable')}</p>;
  }

  return (
    <div className="product-grid">
      {products.map((product) => (
        <ProductCard
          key={product.id || product._id}
          product={product}
          onAddToCart={onAddToCart}
          onAddToWishlist={onAddToWishlist}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
